module.exports = __webpack_public_path__ + "static/media/navbar-background.de0e89a8.jpg";